'use strict';
function eventSeoText(value) {
  return String(value || '').replace(/<(script|style)[^>]*>[\s\S]*?<\/(script|style)\s*>/gi, ' ').replace(/<[^>]*>/g, ' ').replace(/&(nbsp|#160|#xa0);/gi, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
}
function publicEventSeoPolicy(event, now = new Date()) {
  const title = eventSeoText(event?.title);
  const start = event?.startsAt ? new Date(event.startsAt).getTime() : NaN;
  const suppliedEnd = event?.endsAt ? new Date(event.endsAt).getTime() : start + (event?.allDay ? 86400000 : 0);
  const reference = new Date(now).getTime();
  const description = eventSeoText(event?.description);
  const publicRecord = event?.status === 'PUBLISHED' && !event.deletedAt && title && Number.isFinite(start) && Number.isFinite(suppliedEnd) && Number.isFinite(reference);
  const historical = Number.isFinite(suppliedEnd) && suppliedEnd < reference;
  const usefulHistory = description && description !== title;
  return { indexable: Boolean(publicRecord && (!historical || usefulHistory)), historical };
}
module.exports = { eventSeoText, publicEventSeoPolicy };
